import { useReveal } from "@/hooks/useReveal";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import TickerBar from "@/pages/home/components/TickerBar";
import LiveFeedSection from "@/pages/home/components/LiveFeedSection";
import TopicSection from "@/pages/home/components/TopicSection";
import DeepDiveSection from "@/pages/home/components/DeepDiveSection";
import BuzzSection from "@/pages/home/components/BuzzSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import { brandName, contactInfo, faqs, hotRanking } from "@/mocks/home";

const siteUrl = "https://chengweixian.cn";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: brandName,
      description:
        "吃瓜看料专注实时热点与深度爆料，追踪全网热门事件、内幕解析与网友热议精选，现场直击第一手资讯。",
      inLanguage: "zh-CN",
      publisher: { "@id": `${siteUrl}/#organization` },
    },
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      name: brandName,
      url: `${siteUrl}/`,
      slogan: contactInfo.slogan,
      email: contactInfo.email,
      description:
        "面向大众的热点资讯站点，主打现场直击、实时速递、深度爆料与网友热议精选。",
    },
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: "吃瓜看料 - 现场直击 · 实时速递 · 全网热点前线围观",
      description:
        "吃瓜看料专注实时热点与深度爆料，提供全网热门事件追踪、内幕解析与网友热议精选，帮你快速掌握事件全貌。",
      isPartOf: { "@id": `${siteUrl}/#website` },
      about: { "@id": `${siteUrl}/#organization` },
      inLanguage: "zh-CN",
    },
    {
      "@type": "FAQPage",
      "@id": `${siteUrl}/#faq`,
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
    {
      "@type": "ItemList",
      name: "吃瓜看料实时热搜榜",
      itemListElement: hotRanking.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.label,
      })),
    },
  ],
};

export default function Home() {
  useReveal();

  return (
    <>
      <SiteHeader />
      <main>
        <HeroSection />
        <TickerBar />
        <LiveFeedSection />
        <TopicSection />
        <DeepDiveSection />
        <BuzzSection />
        <FaqSection />
        <AboutSection />
      </main>
      <SiteFooter />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  );
}